import { combineReducers } from 'redux';
import cookieConsent from './cookieConsent';

export default combineReducers({
  cookieConsent,
});
